import axios from 'axios'
import deepParseJson from 'utils/deepParseJson'
import store from '../store'
import { onSignOutSuccess } from '../store/auth/sessionSlice'
import { apiError } from 'utils/alerts'
const { REACT_APP_URL } = process.env

const BaseService = axios.create({
    timeout: 120000,
    baseURL: REACT_APP_URL,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
})

BaseService.interceptors.request.use(
    (config) => {
        const rawPersistData = localStorage.getItem('admin')
        const persistData = deepParseJson(rawPersistData)

        let accessToken = persistData.auth.session.token

        if (!accessToken) {
            const { auth } = store.getState()
            accessToken = auth.session.token
        }

        if (accessToken) {
            config.headers['Authorization'] = `Bearer ${accessToken}`
        }

        return config
    },
    (error) => {
        return Promise.reject(error)
    },
)

BaseService.interceptors.response.use(
    (response) => response,
    (error) => {
        const { response } = error
        if (response && [401].includes(response.status)) {
            store.dispatch(onSignOutSuccess())
        }
        apiError(error)
        return Promise.reject(error)
    },
)

export default BaseService
